import React, { useEffect, useState } from 'react';

import { ReactComponent as Search } from '../../../assets/icons/search.svg';
import { IUserCompany } from '../../interfaces/businessData';
import { GenericVoidFunction } from '../../types/genericTypes';
import StyledCircularProgress from '../StyledCircularProgress/StyledCircularProgress';

import './SearchBarNE.scss';

export interface SearchBarProps {
  onSearch: GenericVoidFunction;
  placeholder: string;
  placeholderSmall?: string;
  loading?: boolean;
  company?: IUserCompany;
  onWrite?: GenericVoidFunction;
  previousSearch?: string;
}

const SearchBar = ({
  onSearch,
  placeholder,
  placeholderSmall,
  company,
  loading = false,
  onWrite,
  previousSearch
}: SearchBarProps) => {
  const [searchValue, setSearchValue] = useState<string>('');

  useEffect(() => {
    let isMounted = true;
    if (isMounted) {
      setSearchValue('');
      if (onWrite) {
        onWrite('');
      }
    }
    return () => {
      isMounted = false;
    };
  }, [company]);

  const handleSearch = (e: React.ChangeEvent<HTMLInputElement>) => {
    setSearchValue(e.target.value);
    if (onWrite) {
      onWrite(e.target.value);
    }
  };

  const toggleSearch = () => {
    onSearch(searchValue);
  };

  const handleKeyPress = (event: React.KeyboardEvent) => {
    if (event.key === 'Enter') {
      toggleSearch();
    }
  };

  useEffect(() => {
    setSearchValue(previousSearch ?? '');
  }, [previousSearch]);

  return (
    <div className="search-bar">
      <div className="search-row column-mobile">
        <div className="search-bar-container">
          {placeholderSmall ? (
            <>
              <input
                className="search-input search-bar-big"
                type="text"
                placeholder={placeholder}
                onChange={handleSearch}
                onKeyPress={handleKeyPress}
                value={searchValue}
                disabled={loading}
              ></input>
              <input
                className="search-input search-bar-small"
                type="text"
                placeholder={placeholderSmall}
                onChange={handleSearch}
                onKeyPress={handleKeyPress}
                value={searchValue}
                disabled={loading}
              ></input>
            </>
          ) : (
            <input
              className="search-input"
              type="text"
              placeholder={placeholder}
              onChange={handleSearch}
              onKeyPress={handleKeyPress}
              value={searchValue}
              disabled={loading}
            ></input>
          )}
          <span className="icon-button">
            {loading ? (
              <div className="icon search">
                <StyledCircularProgress size={24} />
              </div>
            ) : (
              <Search className="icon search" onClick={toggleSearch} />
            )}
          </span>
        </div>
      </div>
    </div>
  );
};

export default SearchBar;
